// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"CreateInstructor_breadcrumbs__Sjj2g","container":"CreateInstructor_container__YJ5o+"};